module.exports = __webpack_public_path__ + "static/img/11.9947284.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/11.png
// module id = iPjM
// module chunks = 0